import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  addSubCategory,
  getSubCategories,
  updateSubCategory,
  deleteSubCategory,
} from "./subCategoryAPI";

const initialState = {
  loading: false,
  subCategoryList: [],
  pagination: {},
};

const actions = {
  CREATE_SUB_CATEGORY: "subCategory/CREATE_SUB_CATEGORY",
  GET_SUB_CATEGORIES: "subCategory/GET_SUB_CATEGORIES",
  UPDATE_SUB_CATEGORY: "subCategory/UPDATE_SUB_CATEGORY",
  DELETE_SUB_CATEGORY: "subCategory/DELETE_SUB_CATEGORY",
};

export const createSubCategoryThunk = createAsyncThunk(
  actions.CREATE_SUB_CATEGORY,
  async (payload) => {
    const response = await addSubCategory(payload);
    return response;
  }
);

export const getSubCategoriesThunk = createAsyncThunk(
  actions.GET_SUB_CATEGORIES,
  async (payload) => {
    const response = await getSubCategories(
      payload?.page,
      payload?.per_page,
      payload?.search
    );
    return response;
  }
);

export const updateSubCategoryThunk = createAsyncThunk(
  actions.UPDATE_SUB_CATEGORY,
  async ({ id, ...payload }) => {
    const response = await updateSubCategory(id, payload);
    return response;
  }
);

export const deleteSubCategoryThunk = createAsyncThunk(
  actions.DELETE_SUB_CATEGORY,
  async (id) => {
    const response = await deleteSubCategory(id);
    return response;
  }
);

export const subCategorySlice = createSlice({
  name: "subCategory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSubCategoryThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSubCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Sub-Category created successfully!");
        } else {
          message.error(msg || "Failed to create Sub-Category.");
        }
      })
      .addCase(createSubCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to create Sub-Category.");
      });

    builder
      .addCase(getSubCategoriesThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSubCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data } = action.payload;
        if (success) {
          state.subCategoryList = data?.data || [];
          state.pagination = data?.pagination || {};
        } else {
          message.error(msg || "Failed to fetch Sub-Categories.");
        }
      })
      .addCase(getSubCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to fetch Sub-Categories.");
      });

    builder
      .addCase(updateSubCategoryThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSubCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Sub-Category updated successfully!");
        } else {
          message.error(msg || "Failed to update Sub-Category.");
        }
      })
      .addCase(updateSubCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to update Sub-Category.");
      });

    builder
      .addCase(deleteSubCategoryThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSubCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Sub-Category deleted successfully!");
        } else {
          message.error(msg || "Failed to delete Sub-Category.");
        }
      })
      .addCase(deleteSubCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to delete Sub-Category.");
      });
  },
});

export default subCategorySlice.reducer;
